import Vue from 'vue';

// axios
import axios from 'axios';
let auth = '';
if (localStorage.getItem('token')) {
  auth = 'Bearer ' + localStorage.getItem('token');
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================

  // baseURL: 'https://api.planning.systemstailormade.com/public/api',
  // baseURL: 'https://api.planning.systemstailormade.com/public/api',
  // baseURL: 'https://api.rotagenerator.systemstailormade.com/public/api',
  // baseURL: 'https://api.cisplanning.systemstailormade.com/public/api',
  // baseURL: 'https://api.quality.systemstailormade.com/public/api',
  // baseURL: 'https://api.smcis-rostering.systemstailormade.com/public/api',         //finalized
  // baseURL: 'https://api.ndcis-rostering.systemstailormade.com/public/api',          //no meeting yet
  // baseURL: 'https://api.dscis-rostering.systemstailormade.com/public/api',       //meeting on 22/01
  // baseURL: 'https://api.nlcis-rostering.systemstailormade.com/public/api',      //FINALIZED
  baseURL: 'https://api.nmcis-rostering.systemstailormade.com/public/api',     //had meeting
  // baseURL: 'https://api.sccis-rostering.systemstailormade.com/public/api',     //had meeting


  // baseURL: 'http://127.0.0.1:8000/api',

  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
});

/*
axiosIns.defaults.headers.post["Content-Type"] = "*";
axiosIns.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axiosIns.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
*/

Vue.prototype.$http = axiosIns;

export default axiosIns;
